import { ScoreChart } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING, SIZE } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { marginBottom } from '@sleepstation/style-api-helpers'
import Key from './Key'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const CHART_COLORS = [`#25904e`, `#e7a13d`, `#ad3f26`]
const CHART_LABELS = [``, ``, ``]
const BOUNDARIES = [{ value: 0 }, { value: 11 }, { value: 16 }, { value: 24 }]

const CHART_KEY = [
  {
    label: `Normal daytime sleepiness`,
    color: `#25904e`,
  },
  {
    label: `Mild–moderate daytime sleepiness`,
    color: `#e7a13d`,
  },
  {
    label: `Severe excessive daytime sleepiness`,
    color: `#ad3f26`,
  },
]

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({ spacing: LAYOUT_SPACING.MEDIUM })`
  ${marginBottom(0.25)}
`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const ScoreChartWithKey = ({ results }) => (
  <Layout>
    <ScoreChart
      score={results.score}
      total={results.maximumScore}
      boundaries={BOUNDARIES}
      colors={CHART_COLORS}
      labels={CHART_LABELS}
      hideLabels
      iconName="user"
      markerSize={SIZE.SMALL}
    />
    <Key keyList={CHART_KEY} />
  </Layout>
)

ScoreChartWithKey.propTypes = {
  results: PropTypes.object.isRequired,
}

export default ScoreChartWithKey
